<template>
  <VueSlickCarousel v-bind="settings" @lazyLoad="lazyLoad" ref="slider">
    <slot></slot>
  </VueSlickCarousel>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel';
export default {
  props: ['slidesToShow', 'slidesToShowMobile', 'slidesToShowMedium', 'slidesToScroll', 'showDotsMobile'],
  components: {
    VueSlickCarousel
  },

  data() {
    return {
      settings: {
        autoplay: false,
        slidesToShow: 4,
        slidesToScroll: 2,
        dots: true,
        arrows: true,
        infinite: false,
        //initialSlide: 1,
        waitForAnimate: false,
        swipeToSlide: true,
        draggable: false,
        //lazyLoad: 'progressive',
        touchThreshold: 10,
        speed: 500,
        responsive: [
          {
            breakpoint: 1601,
            settings: {
              slidesToShow: 3.5,
              slidesToScroll: 1,

            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2.5,
              slidesToScroll: 1,
              dots: true
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2.1,
              slidesToScroll: 1,
              dots: this.showDotsMobile,
              arrows: true,
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1.25,
              slidesToScroll: 1,
              dots: this.showDotsMobile,
              arrows: true,
              speed: 300,
            }
          }
        ]
      }
    }
  },

  methods: {
    lazyLoad() {
      this.$nextTick(() => {
        if(this.$refs.slider) {
          var images = this.$refs.slider.$el.querySelectorAll('img[data-src]:not([src])');
          images.forEach(img => window.imgLazyload(img));
        };
      });
    }
  }
}
</script>
